module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_15.e44bd19a.pdf";